module.exports = __webpack_public_path__ + "media/Loop_de_Metodologia_Sixthsense.5e98f940.mp4";